import { useCallback, useState } from 'react';

/**
 * Keeps the last payload after closing so an animated dialog can render the
 * same content through its exit frames. A later show call replaces it.
 */
export function useRetainedDialogState<T>() {
  const [value, setValue] = useState<T | null>(null);
  const [open, setOpen] = useState(false);

  const show = useCallback((nextValue: T) => {
    setValue(nextValue);
    setOpen(true);
  }, []);

  return { value, open, setOpen, show };
}
